export default "__VITE_ASSET__CRzpLe3Y__"